<div class="modal-header">
    <h4 class="modal-title">Editar Categoría de Ocupación</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="mb-3">
            <label class="form-label text-muted small">Ocupación</label>
            <div class="fw-bold">{{ occupationDescription }}</div>
            <div class="small text-muted">Código: {{ occupationCode }}</div>
        </div>
        <div class="mb-3">
            <label class="form-label">Categoría</label>
            <select class="form-select" formControlName="category">
                <option *ngFor="let opt of categoryOptions" [ngValue]="opt.value">{{ opt.label }}</option>
            </select>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Cancelar</button>
    <button type="button" class="btn btn-colonial" (click)="save()" [disabled]="form.invalid || loading">
        Guardar
    </button>
</div>